import React, { useState, useEffect, useRef } from 'react';
import Plotly from 'plotly.js-dist';
import * as d3 from "d3";
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';

function Plot ({onDataChange}) {

  const [dataRows, setDataRows] = useState([]); 

  const defaultConstraintRange = {
  "0": [55, 100],
  "1": [55, 100],
  "2": [55, 100],
  "3": [55, 100],
  "4": [55, 100],
  "5": [55, 100],
  "6": [55, 100],
  "7": [55, 100]}
  ;  


  const [selectedDataRows, setSelectedDataRows] = useState([]);
  const [constraintRange, setConstraintRange] = useState(defaultConstraintRange);
  const dataRowsRef = useRef(dataRows);
  const constraintRangeRef = useRef(constraintRange);
  const selectedDataRowsRef = useRef(selectedDataRows);
  
    // useEffect to monitor changes in dataRows
  useEffect(() => {
    dataRowsRef.current = dataRows;

    
    if (dataRows.length > 0) {
      
      
    }
  }, [dataRows]); // Only execute when dataRows changes


  useEffect(() => {
    constraintRangeRef.current = constraintRange;

    // Ensure dataRows is not empty before processing it
    if (constraintRange.length > 0) {
      
      // Now you can safely work with dataRows here
    }
    selectedDataRowsRef.current = getSelectedDataRows()
    
  
    setSelectedDataRows(selectedDataRowsRef.current)

    onDataChange(selectedDataRowsRef.current)
  }, [constraintRange]); // Only execute when dataRows changes





  useEffect(() => {

    const fetchData = async () => {
      try {
        const response = await fetch('/data-for-plot.csv');
        
        if (!response.ok) {
          throw new Error('Failed to fetch CSV data');
        }

        const csvData = await response.text();
        const rows = d3.csvParse(csvData);
       
         // Check if rows are not empty before setting the state
        if (rows.length > 0) {

            setDataRows(rows); // Set the dataRows state variable

        } else {
            console.warn('CSV data is empty or invalid.');
        }
       
        function unpack(rows, key) {
          return rows.map(function (row) {
            return row[key];
          });
        }


        var data = [
          {
            type: 'parcoords',

            pad: [80, 80, 80, 80],
            line: {
              color: '#86a6e4',
              width: 50,
              colorbar:{
                thickness:90000,
                tickwidth:50,
                outlinewidth:100,
              }
            },
            colorbar: {
                thickness:90000,
                tickwidth:50,
                outlinewidth:100,
            },
            unselected: {
              line:{
                color: 'gray',
                width: 8,
              },
            },
            dimensions: [
              {
                constraintrange: [defaultConstraintRange[0]],
                range: [0, 100],
                label: 'Privacy',
                values: unpack(rows, 'Privacy'),
                multiselect: false,
              },
              {
                constraintrange: [defaultConstraintRange[1]],
                range: [0, 100],
                label: 'Trust',
                values: unpack(rows, 'Trust'),
                multiselect: false,
              },
              {
                constraintrange: [defaultConstraintRange[2]],
                label: 'Effective',
                range: [0, 100],
                values: unpack(rows, 'Effective'),
                multiselect: false,
              },
              {
                constraintrange: [defaultConstraintRange[3]],
                label: 'Intrusive (R)',
                range: [0, 100],
                values: unpack(rows, 'Intrusive (R)'),
                multiselect: false,
              },
              {
                constraintrange: [defaultConstraintRange[4]],
                label: 'Understand.',
                range: [0, 100],
                values: unpack(rows, 'Understand.'),
                multiselect: false,
              },
              {
                constraintrange: [defaultConstraintRange[5]],
                label: 'Disturbing (R)',
                range: [0, 100],
                values: unpack(rows, 'Disturbing (R)'),
                multiselect: false,
              },
              {
                constraintrange: [defaultConstraintRange[6]],
                label: 'Noticeable',
                range: [0, 100],
                values: unpack(rows, 'Noticeable'),
                multiselect: false,
              },
              {
                constraintrange: [defaultConstraintRange[7]],
                label: 'Pref.',
                range: [0, 100],
                values: unpack(rows, 'Pref.'),
                multiselect: false,
              },
            ],
          },
        ];

        var layout = {
          width: 1000,
          height: 450,
          valign: "middle"
        };
        
        const myDiv = document.getElementById('myDiv');

        Plotly.newPlot('myDiv', data, layout);

        var searchString = ""
        var objectKey = ""





        myDiv.on('plotly_restyle', function (eventData) {
  
          eventData.forEach((trace) => {

            var objectKeys = Object.keys(eventData[0])
             objectKey = objectKeys[0].substring(11, 12)

            searchString = `dimensions[${objectKey}].constraintrange`


          });
          
          if (eventData[0][searchString] !== null) {
            setConstraintRange((prevConstraintRange) => ({
               ...prevConstraintRange,
              [objectKey]: eventData[0][searchString][0] 
            }));
          }


          // setConstraintRange(updatedConstraintRange);           

          // Get the selected data rows based on the constraint range
         
                
              
        });

         const initialSelectedDataRows = getSelectedDataRows(defaultConstraintRange);

      // Set the initial selected data rows
      setSelectedDataRows(initialSelectedDataRows);

      // Notify the parent component of the initial selected data rows
      onDataChange(initialSelectedDataRows);


      } catch (error) {
        console.error('Error fetching and plotting data:', error);
      }
    };

    fetchData();
  }, []);




  const getSelectedDataRows = (range) => {

  var selectedPatterns = []

  // Check if dataRows is empty
  if (dataRowsRef.current.length === 0) {
    
    return [];
  } 

  // Filter data rows based on the constraint range
  
  var mapper = { 0: "Privacy", 1: "Trust", 2: "Effective", 3: "Intrusive (R)", 4: "Understand.", 5: "Disturbing (R)", 6: "Noticeable", 7: "Pref."}

  for (const [key, value] of Object.entries(dataRowsRef.current)) {
    var selected = true;
    for (const mapperKey in mapper) {
      var valueLabel = mapper[mapperKey];
      if (value[valueLabel] >= constraintRangeRef.current[mapperKey][0] && value[valueLabel] <= constraintRangeRef.current[mapperKey][1]) {
        
      } else {
        selected = false;
      }
    }
    
     if (selected) {
      selectedPatterns.push(value)
    }

  }
  console.log("selected")
  return selectedPatterns;
};

getSelectedDataRows()

  return (
    <div className="full">
      <div className="container h-100 plot">
          <div id="myDiv">
          
          {/* The plot will be rendered inside this div */}
          </div>
          
      </div>
      <svg className="spacer" preserveAspectRatio="none" viewBox="0 0 1320 235" width="1320" height="235" xmlns="http://www.w3.org/2000/svg"><path d="M1320,0c-177,0.3-385.1,41.199-624.199,122.8C456.7,204.399,224.7,235.8,0,216.899v17.2h1320V0z"></path></svg>
    </div>
  );
};

export default Plot;
